import { Reveal, Eyebrow } from "@/components/Reveal";

export const PROCESS_STEPS = [
  { num: "01", title: "Discover", text: "Understand the business, users, challenges and objectives." },
  { num: "02", title: "Design", text: "Define workflows, user experience, architecture and solution requirements." },
  { num: "03", title: "Build", text: "Develop the platform using modern, maintainable technologies." },
  { num: "04", title: "Test", text: "Perform functional, security, usability and performance testing." },
  { num: "05", title: "Launch", text: "Deploy the solution into production with confidence." },
  { num: "06", title: "Improve", text: "Continue supporting, monitoring and expanding the software." },
];

export default function ProcessTimeline() {
  return (
    <section className="relative bg-void py-28 sm:py-36" data-testid="process-timeline">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <Eyebrow>Development Process</Eyebrow>
          <h2 className="mt-4 max-w-2xl font-display text-2xl font-semibold tracking-tight text-white sm:text-3xl lg:text-4xl">
            Six chapters from idea to intelligent software.
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-3">
          {PROCESS_STEPS.map((step, i) => (
            <Reveal key={step.num} delay={i * 0.08} y={24}>
              <div className="group relative border-l border-slate-800 pl-8" data-testid={`process-step-${step.num}`}>
                <span className="absolute -left-[5px] top-2 h-2.5 w-2.5 rounded-full bg-blue-500 shadow-[0_0_12px_rgba(59,130,246,0.8)]" />
                <p className="font-mono text-4xl font-semibold text-slate-800 transition-colors duration-500 group-hover:text-blue-500/60">
                  {step.num}
                </p>
                <h3 className="mt-3 font-display text-xl font-semibold text-white">{step.title}</h3>
                <p className="mt-2 max-w-xs text-sm leading-relaxed text-slate-400">{step.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
